import React, { Component } from 'react';
import { Layout, Radio, BackTop } from 'antd';
import { IntlProvider, addLocaleData, FormattedMessage } from 'react-intl';
import zh from 'react-intl/locale-data/zh';
import en from 'react-intl/locale-data/en';
import en_US from './locales/en_US';
import zh_CN from './locales/zh_CN';

import MySearch from './MySearch';

import './App.css';

addLocaleData([...en, ...zh]);
// 语言包
const MESSAGES = {
  en: en_US,
  zh: zh_CN,
};

const { Header, Footer, Content } = Layout;

class App extends Component {
  constructor() {
    super();

    this.state = {
      locale:
        localStorage.getItem('locale-language') ||
        navigator.language.split('-')[0],
    };

    // 动态设置title
    document.title = MESSAGES[this.state.locale].title;

    this.changeLocale = this.changeLocale.bind(this);
  }

  changeLocale(e) {
    const localeValue = e.target.value;
    this.setState({
      locale: localeValue,
    });
    localStorage.setItem('locale-language', localeValue);

    // 动态设置title
    document.title = MESSAGES[localeValue].title;
  }

  render() {
    return (
      <IntlProvider
        locale={this.state.locale}
        messages={MESSAGES[this.state.locale]}
      >
        <Layout>
          <Header>
            <span
              onClick={() => {
                document.location.reload();
              }}
              className="header-title"
            >
              <FormattedMessage id="title" />
            </span>
            <div className="languageBtn">
              <Radio.Group
                defaultValue={this.state.locale}
                onChange={this.changeLocale}
              >
                <Radio.Button key="en" value="en">
                  English
                </Radio.Button>
                <Radio.Button key="zh" value="zh">
                  中文
                </Radio.Button>
              </Radio.Group>
            </div>
          </Header>
          <Content>
            <MySearch />
          </Content>
          <Footer>
            <FormattedMessage id="footer" />
          </Footer>
          <BackTop />
        </Layout>
      </IntlProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js